import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { getApiBaseUrl } from '../config/api';
import { logoutAndNavigate } from '../utils/logoutService';
import './Admin.css';

const Admin = ({ onBackToMain }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const API_BASE_URL = getApiBaseUrl();

  useEffect(() => {
    // Check if admin is already authenticated
    const checkAuth = async () => {
      const token = localStorage.getItem('adminToken');
      const userStr = localStorage.getItem('adminUser');
      
      if (token && userStr) {
        try {
          // Verify token is still valid by checking user info
          const response = await fetch(`${API_BASE_URL}/api/admin/me`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          
          if (response.ok) {
            const data = await response.json();
            if (data.success) {
              setUser(data.data);
              setIsAuthenticated(true);
            } else {
              // Token invalid, clear it
              localStorage.removeItem('adminToken');
              localStorage.removeItem('adminUser');
            }
          } else {
            // Handle different error statuses
            if (response.status === 403 || response.status === 401) {
              // Token expired or invalid, clear it
              localStorage.removeItem('adminToken');
              localStorage.removeItem('adminUser');
            }
            // For other errors, don't clear token (might be temporary server issue)
          }
        } catch (error) {
          // Token invalid, clear it
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminUser');
        }
      }
      
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    setUser(null);
    setIsAuthenticated(false);
    
    await logoutAndNavigate({
      userType: 'admin',
      navigate,
      redirectPath: '/admin',
      showNotificationFn: null // No notification in Admin component
    });
  };

  if (isLoading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
        <p>Loading admin panel...</p>
      </div>
    );
  }

  return (
    <div className="admin">
      {isAuthenticated ? (
        <AdminDashboard user={user} onLogout={handleLogout} onBackToMain={onBackToMain} />
      ) : (
        <AdminLogin onLogin={handleLogin} onBackToMain={onBackToMain} />
      )}
    </div>
  );
};

export default Admin;
